import { API } from 'widget/helpers/axios';
import { buildSearchParamsWithLocale } from 'widget/helpers/urlParamsHelper';

/**
 * 类别API模块
 * 根据Chatwoot Widget的架构设计，提供与类别相关的API交互方法
 */
export default {
  /**
   * 获取所有类别
   * @returns {Promise} API响应
   */
  getCategories() {
    try {
      const search = buildSearchParamsWithLocale(window.location.search);
      const url = `/api/v1/widget/categories${search}`;
      return API.get(url);
    } catch (error) {
      throw new Error(`获取类别失败: ${error.message}`);
    }
  },

  /**
   * 根据渠道ID获取类别
   * @param {string|number} channelId - 渠道ID
   * @returns {Promise} API响应
   */
  getCategoriesByChannelId(channelId) {
    try {
      const search = buildSearchParamsWithLocale(window.location.search);
      const params = new URLSearchParams(search);
      params.append('channel_id', channelId);
      const url = `/api/v1/widget/categories/by_channel?${params.toString()}`;
      return API.get(url);
    } catch (error) {
      throw new Error(`通过渠道ID获取类别失败: ${error.message}`);
    }
  },

  /**
   * 获取相关类别
   * @param {string|number} categoryId - 类别ID
   * @returns {Promise} API响应
   */
  getRelatedCategories(categoryId) {
    try {
      const search = buildSearchParamsWithLocale(window.location.search);
      const url = `/api/v1/widget/categories/${categoryId}/related${search}`;
      return API.get(url);
    } catch (error) {
      throw new Error(`获取相关类别失败: ${error.message}`);
    }
  },

  /**
   * 获取类别详情
   * @param {string|number} categoryId - 类别ID
   * @returns {Promise} API响应
   */
  getCategoryDetails(categoryId) {
    try {
      const search = buildSearchParamsWithLocale(window.location.search);
      const url = `/api/v1/widget/categories/${categoryId}${search}`;
      return API.get(url);
    } catch (error) {
      throw new Error(`获取类别详情失败: ${error.message}`);
    }
  },

  /**
   * 获取特定语言的类别
   * @param {string} locale - 语言代码
   * @returns {Promise} API响应
   */
  getCategoriesByLocale(locale) {
    try {
      const params = new URLSearchParams(window.location.search);
      params.set('locale', locale);
      const url = `/api/v1/widget/categories?${params.toString()}`;
      return API.get(url);
    } catch (error) {
      throw new Error(`获取特定语言类别失败: ${error.message}`);
    }
  },
};
